import { $t } from '@/i18n';
import { definePagePlugin } from '../types';

export default definePagePlugin(
  {
    pluginId: 'internal:w-plugin-openai',
    name: $t('k_27bc4c62'),
    description: $t('k_fb9fec5a'),
    icon: 'http://formal-75535.gzc.vod.tencent-cloud.com/default-logo.png',
    deprecated: true,
    propsSchema: {
      type: 'object',
      fields: [],
    },
  },
  () => import('./plugin').then(x => x.default),
);
